import { Validator } from '@vista-digital/validator';
export const defaultCxmConfig = {
    enabled: false,
    url: '',
    salesChannelId: '',
    maxAttempts: 3,
    requestTimeoutInMilliseconds: 1000,
    requestWindowInMilliseconds: 100
};
export const cxmConfigValidator = Validator.object({
    enabled: Validator.boolean(),
    url: Validator.string(),
    salesChannelId: Validator.string(),
    filmTerritoryShortCode: Validator.optional(Validator.string({ minLength: 1, maxLength: 5 })),
    maxAttempts: Validator.optional(Validator.number()),
    requestTimeoutInMilliseconds: Validator.optional(Validator.number()),
    requestWindowInMilliseconds: Validator.optional(Validator.number())
});
//# sourceMappingURL=cxm.js.map